import { send_request } from "./Request";

export const loadDraftProject = (projectId) =>
  send_request(`project-service/project/${projectId}/canvas`, "", {}, "GET");

export const loadPublishedProject = (projectId) =>
  send_request(
    `project-service/project/${projectId}/canvas/published`,
    "",
    {},
    "GET",
  );

export const loadProjectByVersion = (projectId, version) =>
  send_request(
    `project-service/project/${projectId}/canvas/version/${version}`,
    "",
    {},
    "GET",
  );

export const loadDraftCanvasView = (projectId) =>
  send_request(
    `project-service/project/${projectId}/canvas-view`,
    "",
    {},
    "GET",
  );

export const loadPublishedCanvasView = (projectId) =>
  send_request(
    `project-service/project/${projectId}/canvas-view/published`,
    "",
    {},
    "GET",
  );

export const loadCanvasViewByVersion = (projectId, version) =>
  send_request(
    `project-service/project/${projectId}/canvas-view/version/${version}`,
    "",
    {},
    "GET",
  );

export const loadComponentDetail = (
  projectId,
  componentId,
  workflowVersion = null,
  published = false,
) =>
  send_request(
    `project-service/project/${projectId}/component/${componentId}`,
    "",
    {
      ...(workflowVersion != null ? { workflowVersion } : {}),
      ...(published ? { published: true } : {}),
    },
    "GET",
  );

export const loadComponentDetails = (
  projectId,
  componentIds,
  workflowVersion = null,
  published = false,
) =>
  send_request(
    `project-service/project/${projectId}/components/batch-query`,
    {
      componentIds,
      workflowVersion,
      published,
    },
    {},
    "POST",
  );

export const saveCanvasEvent = (projectId, event) =>
  send_request(
    `project-service/project/${projectId}/canvas/save`,
    event,
    {},
    "POST",
  );

export const loadNextComponents = (projectId, componentId) =>
  send_request(
    `project-service/project/${projectId}/canvas/next-components/${componentId}`,
    "",
    {},
    "GET",
  );

export const acquireEditLock = (projectId) =>
  send_request(
    `project-service/project/${projectId}/canvas/lock`,
    "",
    {},
    "POST",
  );

export const heartbeatEditLock = (projectId) =>
  send_request(
    `project-service/project/${projectId}/canvas/lock/heartbeat`,
    "",
    {},
    "POST",
  );

export const releaseEditLock = (projectId) =>
  send_request(
    `project-service/project/${projectId}/canvas/lock`,
    "",
    {},
    "DELETE",
  );
